
import React from "react";
import Byprogram from "../Components/Dashboard/Manage-My-Program/Byprogram";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
const AuthByprogram = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <Byprogram /> : <SessionTimeoutRedirect />
}
export default AuthByprogram;


